/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Display.Align.In
 */

module.exports = {

    BottomCenter: require('./BottomCenter'),
    BottomLeft: require('./BottomLeft'),
    BottomRight: require('./BottomRight'),
    Center: require('./Center'),
    LeftCenter: require('./LeftCenter'),
    QuickSet: require('./QuickSet'),
    RightCenter: require('./RightCenter'),
    TopCenter: require('./TopCenter'),
    TopLeft: require('./TopLeft'),
    TopRight: require('./TopRight')

};



//////////////////
// WEBPACK FOOTER
// ./display/align/in/index.js
// module id = 490
// module chunks = 0